export class NameValue {
  name: string;
  value: string;
}

export enum ModalAnswer {
  OK = 1,
  CANCEL = 2
}

export class ModalResult {
  answer: ModalAnswer;
  data: any;

  constructor(obj: Partial<ModalResult>) {
    Object.assign(this, obj);
  }
}


// WEBPACK FOOTER //
// ./src/app/shared/models/shared.model.ts